import React from 'react';
import { AuthProvider } from './context/AuthContext';
import AppNavigator from './navigation/AppNavigator';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { StyledEngineProvider } from '@mui/material/styles';
import globalStyles from './styles/oldGlobalStyles';
import { BrowserRouter } from 'react-router-dom';
import { SnackbarServiceBridge } from 'context/SnackbarServiceBridge';
import { SnackbarProvider } from 'context/SnackbarContext';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import ScrollToTop from 'components/common/ScrollToTop/ScrollToTop';
import { theme } from 'theme/theme';

const queryClient = new QueryClient();

export default function App() {
  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <BrowserRouter>
          <ScrollToTop />
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <QueryClientProvider client={queryClient}>
                <AuthProvider>

                  <SnackbarProvider>
                    <SnackbarServiceBridge />
                    <AppNavigator />
                  </SnackbarProvider>

                </AuthProvider>
              </QueryClientProvider>
            </ThemeProvider>
          </StyledEngineProvider>
        </BrowserRouter>
      </LocalizationProvider>
    </>
  );
}
